export default "__VITE_ASSET__ChhWJ6vC__"